import { render, staticRenderFns } from "./TeamClaimAdmin.vue?vue&type=template&id=6c9ccef3&scoped=true"
import script from "./TeamClaimAdmin.vue?vue&type=script&lang=js"
export * from "./TeamClaimAdmin.vue?vue&type=script&lang=js"
import style0 from "./TeamClaimAdmin.vue?vue&type=style&index=0&id=6c9ccef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9ccef3",
  null
  
)

export default component.exports